import { Service, ServiceData } from "./settings.types";

export type ServiceConfiguration = Readonly<
  Pick<ServiceData, "service"> & Partial<ServiceData>
>;

type ServiceConfigurationMap = Readonly<{
  [key: string]: ServiceConfiguration;
}>;

const SubscriberSafety: ServiceConfigurationMap = {
  Standard: { service: Service.SubscriberSafety, "standard-support": true },
  SBSingle: { service: Service.SubscriberSafety, "sb-single-support": true },
  SBMultiple: {
    service: Service.SubscriberSafety,
    "sb-multiple-support": true,
  },
};

const PersonalInternet: ServiceConfigurationMap = {
  Single: { service: Service.PersonalInternet, "household-support": true },
  Multiple: { service: Service.PersonalInternet, "perdevice-support": true },
};

const SecureBusiness: ServiceConfigurationMap = {
  Single: { service: Service.SecureBusiness, "single-profile-support": true },
  Multiple: {
    service: Service.SecureBusiness,
    "multiple-profiles-support": true,
  },
};

export const Configuration = {
  SubscriberSafety,
  PersonalInternet,
  SecureBusiness,
};
